import { useRef, useState } from "react";
import InputBox from "../Login/InputBox";
import ERROR from "../../component/ERROR/ERROR";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import "./styles.css";

const initialState = {
  fullName: "",
  email: "",
  message: ""
};

const Contact = () => {
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const form = useRef();
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const validator = formValidation(formData);

    if (Object.keys(validator).length > 0) {
      setFormErrors(validator);
      return;
    }

    emailjs
      .sendForm(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        form.current,
        "YOUR_PUBLIC_KEY"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const formValidation = (data) => {
    const error = {};
    const { fullName, email, message } = data;
    const emailRegEx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (fullName.length < 4 || fullName.length > 10)
      error.fullName = "Nom non valid";

    if (!emailRegEx.test(email)) error.email = "Email non valid";

    if (message.length < 20)
      error.message = "le message doit être supérieur à 10 caractères";

    return error;
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => setFormData({ ...prev, [name]: value }));
  };
  return (
    <motion.section
      initial={{ opacity: 0, transform: "translateY(10%)" }}
      animate={{ opacity: 1, transform: "translateY(0%)" }}
      exit={{ opacity: 0 }}
      className="contact-us"
    >
      <div className="container">
        <div className="contact-us__container login__form">
          <h2>Contactez Nous</h2>
          <div className="contact-us__form ">
            <form
              ref={form}
              onSubmit={handleFormSubmit}
              onChange={handleFormChange}
            >
              {Object.keys(formErrors).length ? (
                <ERROR errorObject={formErrors} />
              ) : null}
              <InputBox
                id="contactFullName"
                name="fullName"
                label="Nom Complete"
                type="text"
              />
              <InputBox
                id="contactEmail"
                name="email"
                label="Email"
                type="email"
              />
              <InputBox
                id="contactMessage"
                name="message"
                label="Message"
                type="text"
              />
              <button class="btn btn-primary">Envoyer</button>
            </form>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
export default Contact;
